<template>
  <b-card no-body class="reader-new">
    <b-card-header class="email-detail-head" style="display:none;">
      <div
        class="user-details d-flex justify-content-between align-items-center flex-wrap"
      >
        <div class="mail-items">

          <!-- <span class="font-small-3 text-muted mr-25">{{ newsData.hat }}</span> -->
        </div>
      </div>
      <div class="mail-meta-item d-flex align-items-center">
        <!-- <small class="mail-date-time text-muted">{{
          formatDate(newsData.dt_create, {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
          })
        }}</small> -->
        <!-- Mail Action DD -->
        <manage-news-dropdown-actions
          :status="newsData.event_status"
          @action-edit="$emit('action-edit', newsData)"
          @action-copy="$emit('action-copy', newsData)"
          @action-delete="$emit('action-delete', newsData)"
        ></manage-news-dropdown-actions>
      </div>
    </b-card-header>

    <b-card-body class="">
      <span class="dot" :class="{'green': newsData.active, 'red': !newsData.active}" style="margin-right: 5px"></span>
      <b-alert
        v-height-fade.appear
        variant="danger"
        :show="isSchedule"
        class="alert-send-clock"
      >
      <div class="alert-body">
        <feather-icon
          icon="ClockIcon"
          class="mr-50"
        />
        {{$t('MANAGE_NEWS_VIEW.Scheduled_to')}}
        {{
          formatDate(newsData.dt_scheduled, {
            dateStyle: "long",
            timeStyle: "medium",
          })
        }}.
      <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-primary"
          class="btn btn-flat-primary btn-sm btn-edit-programsend"
          pill
          size="sm"
          @click.stop="$emit('action-edit', newsData)"
        >
          {{$t('MANAGE_NEWS_VIEW.Edit')}}
        </b-button>
      </div>
    </b-alert>

      <b-badge v-for="source in newsData.source" :key="source._id" variant="light-primary" class="origem-badge" href="#" @click.stop="$emit('action-filter-origin', source)">
        <feather-icon icon="FlagIcon" class="mr-25" />
        <span>{{ source.name }}</span>
      </b-badge>
      <div v-if="newsData.hat" class="text-hat">
        {{ getHat }}
      </div>

      <div class="title-new">{{ newsData.content.title.data }}</div>
      <div
        v-if="newsData.content.abstract.data"
        v-html="newsData.content.abstract.data"
        class="sumary-title"
      />
      <div class="subject-name">
        <b-badge
          variant="light-warning rounded tag-important"
          v-if="newsData.exclusive"
          href="#"
          @click.stop="$emit('action-filter-exclusive', true)"
        >
          <span>{{$t('MANAGE_NEWS_VIEW.Exclusive')}}</span>
        </b-badge>
        <b-badge
          variant="light-warning rounded tag-important"
          v-if="isFlashes(newsData.layout)"
          href="#"
          @click.stop="$emit('action-filter-flashes', true)"
        >
          <span>{{$t('MANAGE_NEWS_VIEW.Flashes')}}</span>
        </b-badge>
        <b-badge
          variant="light-danger rounded tag-important"
          v-if="isImportant(newsData.importance)"
          href="#"
          @click.stop="$emit('action-filter-important', newsData.importance)"
        >
          <!-- <feather-icon icon="FlagIcon" class="mr-25" /> -->
          <span>{{$t('MANAGE_NEWS_VIEW.Important')}}</span>
        </b-badge>
        <b-badge
          variant="light-danger rounded tag-important"
          v-if="newsData.inLive"
          href="#"
          @click.stop="$emit('action-filter-inLive', true)"
        >
          <!-- <feather-icon icon="FlagIcon" class="mr-25" /> -->
          <span>{{$t('MANAGE_NEWS_VIEW.InLive')}}</span>
        </b-badge>

        <b-badge
          href="#"
          v-for="(subject, index) in newsData.subjects"
          :key="index + 1"
          pill
          class="mr-25"
          v-b-tooltip.click.v-primary
          variant="light-primary rounded"
          @click.stop="$emit('action-filter-subject', subject)"
        >
          {{ subject.name }}
        </b-badge>
        <b-badge
          href="#"
          pill
          class="mr-25"
          v-b-tooltip.click.v-primary
          variant="light-success rounded"
          v-if="newsData.highlight"
        >
          Destaque
        </b-badge>
      </div>
      
      <div v-if="isTemplate">
        <b>Template:</b> {{newsData.template_name}}
      </div>
      <div v-if="newsData.newsContent.length > 0">
        <b>{{$t('MANAGE_NEWS_VIEW.Content')}}:</b> {{newsData.newsContent.map(item => item.namePtBr).join(',')}}
      </div>
      <div v-if="newsData.channel.length > 0">
        <small><b>{{$t('MANAGE_NEWS_VIEW.Channel')}}:</b> {{newsData.channel.map(item => item.name).join(', ')}}</small>
      </div>
      <div v-if="newsData.country">
        <small><b>{{$t('MANAGE_NEWS_VIEW.Country')}}:</b> {{newsData.country.map(item => item.name).join(', ')}}</small>
      </div>
      <div v-if="newsData.characteristic">
        <small><b>Caracteristica:</b> {{newsData.characteristic.namePtBr}}</small>
      </div>
      <div v-if="newsData.periodicity">
        <small><b>Periodicidade:</b> {{newsData.periodicity.namePtBr}}</small>
      </div>
      <div v-if="newsData.reportType">
        <small><b>Tipo Relatório:</b> {{newsData.reportType.namePtBr}}</small>
      </div>
      <div v-if="newsData.dt_report">
        <small><b>Data Relatório:</b> {{getFormattedDateReport(newsData.dt_report)}}</small>
      </div>
      <div v-if="newsData.clientGroup.length > 0">
        <small><b>Grupo de cliente:</b> {{newsData.clientGroup}}</small>
      </div>
      <!-- <div v-if="newsData.clientGroup.length > 0">
        <small><b>Grupo de clientes:</b> {{newsData.clientGroup.map(item => item.name).join(', ')}}</small>
      </div> -->
      <div v-if="newsData.highlight">
        <small><b>Validade do destaque:</b> {{formatDate(newsData.highlight_date, {dateStyle: "medium",timeStyle: "medium"})}} </small>
      </div>
      <div v-if="newsData.announcement_date">
        <small><b>Validade do anúncio:</b> {{formatDate(newsData.announcement_date, {dateStyle: "medium",timeStyle: "medium"})}} </small>
      </div>
      
      <div v-if="newsData.inLive">
        <small><b>Ao Vivo até:</b> {{formatDate(newsData.inLive_validate, {dateStyle: "medium",timeStyle: "medium"})}} </small>
      </div>

      <div v-if="newsData.asset_reference && newsData.asset_reference.length > 0">
        <small><b>Referencia de ativos:</b> {{newsData.asset_reference.map(item => item.name).join()}}</small>
      </div>
      <div v-if="newsData.external_source_origin">
        <small><b>Origem(fonte) da notícia:</b> {{newsData.external_source_origin}}</small>
      </div>

        
      <div class="date-post" style="margin-top: 5px">
        <span
          >{{
            formatDate(newsData.dt_publish, {
              dateStyle: "long",
              timeStyle: "medium",
            })
          }}
          <small><b>{{ newsData.author.name }}</b></small> | {{$t('MANAGE_NEWS_VIEW.Updated')}}
          {{
            formatDate(newsData.dt_update, {
              dateStyle: "long",
              timeStyle: "medium",
            })
          }}</span
        >
      </div>

      
      <div v-if="isEvent">
        <hr>
        <h3>Dados do {{newsData.disclosureType == 1 ? 'Anúncio' : 'Convite'}}</h3>
        <div><small><b>Tipo:</b> {{newsData.eventScheduleType == 1 ? 'Online' : 'Presencial'}}</small></div>
        <!-- <div><small><b>Data de inicio:</b> {{ formatDate(newsData.eventScheduleDuration_dateTo, {dateStyle: "short"}) }}</small></div> -->
        <div><small><b>Data de inicio:</b> {{ formatDate(newsData.eventScheduleDuration_dateTo, {dateStyle: "short"}) }} {{newsData.eventScheduleDuration_hourTo}}</small></div>
        <!-- <div><small><b>Horário:</b> {{newsData.eventScheduleDuration_hourTo}}</small></div> -->
        <!-- <div v-if="newsData.eventScheduleDuration_dateFrom"><small><b>Data final:</b> {{ formatDate(newsData.eventScheduleDuration_dateFrom, {dateStyle: "short"}) }}</small></div> -->
        <div v-if="newsData.eventScheduleDuration_dateFrom"><small><b>Data final:</b> {{ formatDate(newsData.eventScheduleDuration_dateFrom, {dateStyle: "short"}) }} {{newsData.eventScheduleDuration_hourFrom}}</small></div>
        <!-- <div><small><b>Dia inteiro:</b> {{getBolleanTraslate(newsData.eventScheduleAllDay)}}</small></div> -->
        <!-- <div><small><b>Local:</b> {{newsData.eventScheduleLocation}}</small></div> -->
        <!-- <div v-if="newsData.eventSchedulePrice"><small><b>Preço:</b> {{newsData.eventSchedulePrice}}</small></div> -->
        <div v-if="newsData.eventScheduleLink"><small><b>Link:</b> <a :href="newsData.eventScheduleLink" target="_blank">{{newsData.eventScheduleLink}}</a></small></div>
        <div v-if="newsData.eventScheduleRelatedNews"><small><b>Evento Relacionado:</b> {{newsData.eventScheduleRelatedNews.content.title.data}}</small></div>
      </div>
      <hr />
      <div class="tags-origem"></div>
      

      <div class="content-tags">
        <!-- <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <div class="">
              <h6 class="mb-0">
                Última atualização:
                <span
                  >{{
                    formatDate(newsData.dt_update, {
                      dateStyle: "short",
                      timeStyle: "medium",
                    })
                  }}
                </span>
              </h6>
              <small
                >Data do envio:

                <span>{{
                  formatDate(newsData.dt_publish, {
                    dateStyle: "short",
                    timeStyle: "medium",
                  })
                }}</span>
              </small>
            </div>
          </div>
        </div> -->

        <!-- <div v-if="newsData.summary" v-html="newsData.summary" class="sumary" /> -->
        <div v-if="newsData.thumb" class="news-image news-thumb">
          <h5>{{$t('MANAGE_NEWS_VIEW.Thumb')}}</h5>
          <b-img :src="newsData.thumb.image_path"></b-img>
        </div>
        <div v-if="newsData.image" class="news-image">
          <h5>{{$t('MANAGE_NEWS_VIEW.Image')}}</h5>
          <b-img :src="newsData.image.image_path"></b-img>
          <div class="infos-image" v-if="newsData.image_description || newsData.image.copyright">
            <span v-if="newsData.image_description" class="description-info">{{
              newsData.image_description
            }}</span>
            <span v-if="newsData.image.copyright"><b>{{$t('MANAGE_NEWS_VIEW.Copyright')}} {{
              newsData.image.copyright
            }}</b></span>
          </div>
        </div>

        <!-- <div class="col-md-12 key-points" v-if="newsData.related_news.length > 0">
          <b-list-group flush>
            <b-list-group-item v-for="(item, index) in newsData.related_news" :key="index" :class="{'text-link': item.type=='link'}" @click="openRelatedNews(item)">
              <feather-icon icon="ArrowRightIcon" class="mr-25" />
              {{item.title}}
              </b-list-group-item>
          </b-list-group>
        </div> -->

        <div
          v-if="newsData.content.body.data"
          v-html="newsData.content.body.data"
          class="content-new"
        />
      </div>

      <!-- APP FIELDS -->
      <b-row v-if="newsData.external_url">
        <h5>{{$t('MANAGE_NEWS_VIEW.Url_Complementary')}}:</h5>
        <b-link :href="newsData.external_url" target="_blank" class="mt-75">
          <span class="text-muted font-weight-bolder align-text-top">{{$t('MANAGE_NEWS_VIEW.Link')}}</span>
        </b-link>
      </b-row>
      <b-row v-if="newsData.external_label_btn">
        <h5>{{$t('MANAGE_NEWS_VIEW.Button_Name')}}:</h5>
        <div class="mail-message">{{ newsData.external_label_btn }}</div>
      </b-row>
      <b-row v-if="newsData.image_copyright">
        <h5>{{$t('MANAGE_NEWS_VIEW.Image_Copyright')}}:</h5>
        <div class="mail-message">{{ newsData.image_copyright }}</div>
      </b-row>

      <!-- MEDIA -->
<!--      <div>-->
<!--        <div class="row row-author">-->
<!--          <div class="col-avatar">-->
<!--            <span-->
<!--              class="b-avatar badge-minimal badge-light-primary rounded-circle"-->
<!--              style="width: 40px; height: 40px;">-->
<!--              <span class="b-avatar-img author">-->
<!--                <img-->
<!--                  src="http://dev-plataforma-cma.cma.com.br:8081/publisher/public/uploads/usercontrib-thumb/usercontrib_1619814774839.jpg"-->
<!--                  alt="avatar"-->
<!--                />-->
<!--              </span>-->
<!--            </span>-->
<!--          </div>-->
<!--          <div class="col-md-10 col-info">-->
<!--            <span>{{ newsData.user_update.name }}</span>-->
<!--            <span>{{ newsData.user_update.resume }}</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <hr />-->



      <hr v-if="newsData.related_news">
      <b-card class="container-related-news-detail">
        <div v-if="newsData.related_news && newsData.related_news.news && newsData.related_news.news.length > 0 && !(newsData.related_news.free_title && newsData.related_news.free_text)">
          <h5>
            Notícias Relacionadas:
          </h5>
        </div>
        <div v-else-if="newsData.related_news && newsData.related_news.news && newsData.related_news.news.length > 0 && newsData.related_news.free_title && newsData.related_news.free_text">
          <h5 class="related-news-free-title">
            {{ newsData.related_news.free_title }}
          </h5>
          <h6 class="related-news-free-text">
            {{ newsData.related_news.free_text }}
          </h6>
        </div>
        <b-list-group v-if="newsData.related_news">
          <b-list-group-item v-for="(item, index) in newsData.related_news.news" :key="index" class="list-item-related-news" @click="openNews(item)">
            {{ item.content.title.data }}
          </b-list-group-item>
        </b-list-group>
      </b-card>



      <div class="tags">
        <b-badge
          href="#"
          v-for="(tag, index) in newsData.tags"
          :key="index + 1"
          pill
          class="mr-25"
          :variant="`light-secondary`"
        >
          <feather-icon icon="TagIcon" />
          {{ tag.name }}
        </b-badge>

        <b-badge
          href="#"
          v-for="(tag, index) in newsData.topic"
          :key="index + 1"
          pill
          class="mr-25"
          :variant="`light-primary`"
        >
          <feather-icon icon="TagIcon" />
          {{ tag.namePtBr }}
        </b-badge>
      </div>

      <div v-if="newsData.document" class="attachment cursor-pointer" @click="openDocument(newsData.document)">
        <b-img rounded :src="documentImg"></b-img>
        <h6 class="mt-1">{{ newsData.document.original_filename }}</h6>
        <!-- <small>{{ newsData.document.image_filename }}</small> -->
      </div>

      <hr v-if="newsData.youtubeId || newsData.soundcloud || newsData.spotify || newsData.audio"/>
      <b-row v-if="newsData.youtubeId">
        <h5>{{$t('MANAGE_NEWS_VIEW.Youtube')}}:</h5>
        <b-col md="12">
          <iframe
            :src="urlYoutube"
            width="600"
            height="400"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
          ></iframe>
        </b-col>
      </b-row>

      <b-row v-if="newsData.soundcloud">
        <h5>{{$t('MANAGE_NEWS_VIEW.Soundcloud')}}:</h5>
        <iframe
          id="sc-widget"
          :src="urlSoundcloud"
          width="100%"
          height="200"
          scrolling="no"
          frameborder="no"
        ></iframe>
      </b-row>
      <b-row v-if="newsData.spotify">
        <h5>{{$t('MANAGE_NEWS_VIEW.Spotify')}}:</h5>
        <b-col md="12">
          <iframe :src="urlSpotify" width="100%" height="200" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
        </b-col>
      </b-row>
      <b-row v-if="newsData.audio">
        <b-col md="12" v-if="newsData.thumbPodcast" class="news-image">
          <h5>{{$t('MANAGE_NEWS_VIEW.Thumb_Podcast')}}</h5>
          <b-img :src="newsData.thumbPodcast.image_path" style="width: 30%"></b-img>
        </b-col>
        <h5>{{$t('MANAGE_NEWS_VIEW.Audio')}}:</h5>
        <!-- TODO adicionar audio player -->
        <b-col md="12">
          <p>- {{newsData.audio.original_filename}}</p>
          <audio-player :src="newsData.audio.image_path"/>
        </b-col>
      </b-row>

      <b-row v-if="newsData.thumb_path">
        <h5>{{$t('MANAGE_NEWS_VIEW.Thumb')}}</h5>
        <img :src="newsData.thumb_path" width="150px" height="150px" />
      </b-row>
      <b-row v-if="newsData.image_path">
        <h5>{{$t('MANAGE_NEWS_VIEW.Image')}}</h5>
        <img :src="newsData.image_path" width="150px" height="150px" />
      </b-row>
      <!-- eslint-enable -->
    </b-card-body>

    <b-card-footer v-if="newsData.document_path || newsData.pdf_content">
      <div class="mail-attachments" v-if="newsData.document_path">
        <div class="d-flex align-items-center mb-1">
          <feather-icon icon="PaperclipIcon" size="16" />
          <h5 class="font-weight-bolder text-body mb-0 ml-50">{{$t('MANAGE_NEWS_VIEW.Attachment')}}</h5>
        </div>

        <div class="d-flex flex-column">
          <b-link :href="newsData.document_path" target="_blank" class="mt-75">
            <!-- <b-img
              :src="attachment.thumbnail"
              width="16px"
              class="mr-50"
            /> -->
            <span class="text-muted font-weight-bolder align-text-top">{{
              newsData.document_filename
            }}</span>
            <!-- <span class="text-muted font-2small-2 ml-25">({{ attachment.size }})</span> -->
          </b-link>
        </div>
      </div>

      <div v-if="newsData.pdf_content" class="pdf-content-section mt-2">
        <div class="d-flex align-items-center">
          <feather-icon icon="FileTextIcon" size="16" class="mr-50" />
          <h5 class="font-weight-bolder text-body mb-0">PDF Content</h5>
          <b-button
            v-ripple.400="'rgba(186, 85, 211, 0.15)'"
            size="sm"
            variant="flat-primary"
            class="ml-auto"
            @click="showPdfModal = true"
          >
            <feather-icon icon="EyeIcon" size="16" class="mr-25" />
            Visualizar
          </b-button>
        </div>
      </div>
    </b-card-footer>

    <b-modal
      ref="pdfContentModal"
      v-model="showPdfModal"
      id="pdf-content-modal"
      title="PDF Content - Texto Extraído"
      size="lg"
      scrollable
      centered
      hide-footer
    >
      <div class="pdf-content-viewer">
        <div class="pdf-content-text">
          {{ newsData.pdf_content || 'Nenhum conteúdo extraído' }}
        </div>
        <div class="mt-2 text-muted font-small-2">
          <small>
            <strong>Informações:</strong><br>
            Caracteres: {{ newsData.pdf_content ? newsData.pdf_content.length : 0 }} |
            Linhas: {{ newsData.pdf_content ? newsData.pdf_content.split('\n').length : 0 }}
          </small>
        </div>
        <div class="mt-3 d-flex justify-content-end gap-2">
          <b-button
            v-ripple.400="'rgba(186, 85, 211, 0.15)'"
            variant="flat-warning"
            size="sm"
            :disabled="sanitizingPdf"
            @click="sanitizePdfContent"
          >
            <feather-icon icon="RefreshCwIcon" size="16" class="mr-25" />
            {{ sanitizingPdf ? 'Sanitizando...' : 'Re-sanitizar' }}
          </b-button>
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="copyToClipboard"
          >
            <feather-icon icon="CopyIcon" size="16" class="mr-25" />
            Copiar
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            @click="showPdfModal = false"
          >
            Fechar
          </b-button>
        </div>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BImg,
  BButton,
  BAlert,
  BCard,
  BCardHeader,
  BCardBody,
  BCardFooter,
  BLink,
  BRow,
  BCol,
  BBadge,
  BModal,
  VBTooltip,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import { formatDate } from "@core/utils/filter";
import translateBooleanToLocale from "@/helpers/translate-field-helper";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import formatFieldHelper from "@/helpers/format-field-helper";
import ManageNewsDropdownActions from "./ManageNewsDropdownActions.vue";
import AppConstants from "@/appConstants";
import Ripple from "vue-ripple-directive";
import { heightFade } from '@core/directives/animations'
import newsService from "@/providers/newsService";

export default {
  components: {
    BButton,
    BAlert,
    BImg,
    BCard,
    BCol,
    BCardHeader,
    BCardBody,
    BCardFooter,
    BLink,
    BRow,
    BBadge,
    BModal,
    ManageNewsDropdownActions,
    /* eslint-disable */
    BListGroup,
    /* eslint-disable */
    BListGroupItem,
  },
  directives: {
    "b-tooltip": VBTooltip,
    'height-fade': heightFade,
    Ripple
  },
  props: {
    newsData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPdfModal: false,
      sanitizingPdf: false,
    };
  },
  computed: {
    isTemplate() {
      return this.newsData.event_status == AppConstants.EVENT_STATUS.TEMPLATE;
    },
    isEvent() {
      return this.newsData.layout == AppConstants.NEWS_LAYOUT.EVENT;
    },
    getHat() {
      if (this.newsData.hat.length > 0) {
        return this.newsData.hat.map(item => item.name).toString();
      }
      return '';
    },
    isSchedule() {
      console.log(this.newsData);
      return this.newsData.event_status == AppConstants.EVENT_STATUS.SCHEDULED;
    },
    urlYoutube() {
      if (this.newsData.youtubeId) {
        return `${AppConstants.URL_YOUTUBE_EMBED}${this.newsData.youtubeId}`;
      }
      return "";
    },
    urlSoundcloud() {
      if (this.newsData.soundcloud) {
        return `${AppConstants.URL_SOUNDCLOUD_EMBED}${this.newsData.soundcloud}`;
      }
      return "";
    },
    urlSpotify() {
      if (this.newsData.spotify) {
        return `${AppConstants.URL_SPOTIFY_EMBED}${this.newsData.spotify}`;
      }
      return "";
    },
    documentImg() {
      if (this.newsData.document) {
        const doc = AppConstants.MEDIA_DOCUMENT_TYPE.find(
          (item) => item.values.indexOf(this.newsData.document.extension) >= 0
        );
        if (doc) {
          return require(`@/assets/images/icons/${doc.img_name}`);
        }
      }
      return "";
    },
  },
  methods: {
    getDateTimezone(dt) {
      return convertDatetimeHelper.getDateWithoutTimezone(dt);
    },
    openDocument(item) {
      this.$emit('open-document',item);
    },
    openRelatedNews(item) {
      if (item.type == AppConstants.RELATED_NEWS_TYPE_LINK.value) {
        this.$emit('open-related-news', item.news);
      }
    },
    openNews(item) {
      this.$emit("open-news-view", item);
    },
    copyToClipboard() {
      const text = this.newsData.pdf_content;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$bvToast.toast('Conteúdo copiado para a área de transferência!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
            toaster: 'b-toaster-top-right',
          });
        }).catch(() => {
          this.fallbackCopyToClipboard(text);
        });
      } else {
        this.fallbackCopyToClipboard(text);
      }
    },
    fallbackCopyToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.$bvToast.toast('Conteúdo copiado para a área de transferência!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-right',
        });
      } catch {
        this.$bvToast.toast('Erro ao copiar conteúdo', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right',
        });
      }
      document.body.removeChild(textArea);
    },
    async sanitizePdfContent() {
      try {
        this.sanitizingPdf = true;
        const response = await newsService.sanitizePdfContent(this.newsData._id);
        this.newsData.pdf_content = response.pdf_content;

        this.$bvToast.toast('PDF re-sanitizado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-right',
        });
      } catch (error) {
        console.error('Erro ao sanitizar PDF:', error);
        this.$bvToast.toast(error?.response?.data?.message || 'Erro ao sanitizar PDF', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right',
        });
      } finally {
        this.sanitizingPdf = false;
      }
    },
  },
  setup() {
    const isFlashes = (layout) => {
      return layout == AppConstants.NEWS_LAYOUT.FLASHES;
    };
    const isImportant = (importantId) => {
      return importantId == AppConstants.IMPORTANT.IMPORTANT.id;
    };
    const getImportantLabel = (field) => {
      return formatFieldHelper.getImportantLabel(field);
    };
    const getBolleanTraslate = (field) => {
      return translateBooleanToLocale.translateBooleanToLocale(field);
    };

    const getFormattedDateReport = (field) => {
      if (field) {
        return convertDatetimeHelper.convertDateToStringFormatReport(field);
      }
      return "";
    };

    return {
      formatDate,
      getBolleanTraslate,
      getFormattedDateReport,
      getImportantLabel,
      isImportant,
      isFlashes
    };
  },
};
</script>

<style lang="scss">
// Thumb é pequena (usada nos cards da plataforma); esticar a 100% pixeliza
.news-image.news-thumb img {
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 5px;
}
.pdf-content-text {
  max-height: 500px;
  overflow-y: auto;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  background-color: #f8f9fa;
  color: #333;
}
.dark-layout .pdf-content-text {
  background-color: #1e1e1e !important;
  color: #e0e0e0 !important;
  border-color: #444 !important;
}
</style>